import request from '@/utils/request'; // 获取区域内小区信息

export function fetchgetCommunity(data) {
  return request({
    url: '/pmslayer/api/analysis/getCommunity',
    method: 'post',
    data: data
  });
} // 最新通知

export function fetchNotice(data) {
  return request({
    url: '/pmslayer/api/screen/list',
    method: 'post',
    data: data
  });
} // 报修统计

export function repairCount(data) {
  return request({
    url: '/pmslayer/api/screen/repairCount',
    method: 'post',
    data: data
  });
} // 问卷调查

export function surveyCount(data) {
  return request({
    url: '/pmslayer/api/screen/surveyCount',
    method: 'post',
    data: data
  });
} // 近七天统计投诉管理

export function complaintManageCount(data) {
  return request({
    url: '/pmslayer/api/screen/complaintManageCount',
    method: 'post',
    data: data
  });
} // 租赁合同近七天合同到期告警

export function leaseContractCount(data) {
  return request({
    url: '/pmslayer/api/screen/leaseContractCount',
    method: 'post',
    data: data
  });
} // 租赁合同近七天合同到期告警

export function leaseContractCountList(data) {
  return request({
    url: '/pmslayer/api/screen/leaseContractCountList',
    method: 'post',
    data: data
  });
} // 应收已收欠费统计

export function recodeOutCount(data) {
  return request({
    url: '/pmslayer/api/screen/recodeOutCount',
    method: 'post',
    data: data
  });
} // 可租赁房源统计

export function houseCount(data) {
  return request({
    url: '/pmslayer/api/screen/houseCount',
    method: 'post',
    data: data
  });
} //近七天统计-设备告警

export function deviceAlarmCount(data) {
  return request({
    url: '/pmslayer/api/cockpit/deviceAlarmCount',
    method: 'post',
    data: data
  });
} //近七天统计-投诉建议

export function complaintSuggestionCount(data) {
  return request({
    url: '/pmslayer/api/cockpit/complaintSuggestionCount',
    method: 'post',
    data: data
  });
} //近七天统计-报事报修

export function newrepairCount(data) {
  return request({
    url: '/pmslayer/api/cockpit/repairCount',
    method: 'post',
    data: data
  });
} //活动统计详情

export function activityStatistics(data) {
  return request({
    url: '/pmslayer/api/cockpit/activityStatistics',
    method: 'post',
    data: data
  });
} //事项列表

export function findEventList(data) {
  return request({
    url: '/pmslayer/api/cockpit/findEventList',
    method: 'post',
    data: data
  });
} //设备管理-总计

export function findDeviceState(data) {
  return request({
    url: '/pmslayer/api/cockpit/findDeviceState',
    method: 'post',
    data: data
  });
} //设备类型列表

export function findDeviceSysTypeState(data) {
  return request({
    url: '/pmslayer/api/cockpit/findDeviceSysTypeState',
    method: 'post',
    data: data
  });
} //报修工单统计

export function findRepairOrderCount(data) {
  return request({
    url: '/pmslayer/api/cockpit/findRepairOrderCount',
    method: 'post',
    data: data
  });
} //资源统计

export function findHouseCount(data) {
  return request({
    url: '/pmslayer/api/cockpit/findHouseCount',
    method: 'post',
    data: data
  });
} //收费统计

export function findChargeCount(data) {
  return request({
    url: '/pmslayer/api/cockpit/findChargeCount',
    method: 'post',
    data: data
  });
} //应收已收欠费统计

export function findChargeItemCount(data) {
  return request({
    url: '/pmslayer/api/cockpit/findChargeItemCount',
    method: 'post',
    data: data
  });
}